import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// RouterTab 内置路由
import { RouterTabRoutes } from "vue-router-tab";

const routes = [
    { path: "*", redirect: "/main" },
    {
        path: "/main",
        name: "Main",
        component: () => import(/* webpackChunkName: "main" */ "./views/main.vue"),
        children: [
            ...RouterTabRoutes,
            { path: "/main", redirect: "/main/index" },
            {
                path: "/main/index",
                name: "index",
                component: () => import(/* webpackChunkName: "main" */ "./views/0首页/index.vue"),
                meta: { title: "首页", closable: false },
            },

            //收款
            {
                path: "/main/shoukuan/mx",
                name: "shoukuan_mx",
                component: () => import(/* webpackChunkName: "shoukuan" */ "./views/1收款/1收款明细.vue"),
                meta: { title: "收款明细", closable: true },
            },
            {
                path: "/main/shoukuan/shrjl",
                name: "shoukuan_shrjl",
                component: () => import(/* webpackChunkName: "shoukuan" */ "./views/1收款/2收款日记录.vue"),
                meta: { title: "商户日记录", closable: true },
            },
            {
                path: "/main/shoukuan/mdrjl",
                name: "shoukuan_mdrjl",
                component: () => import(/* webpackChunkName: "shoukuan" */ "./views/1收款/5门店日记录.vue"),
                meta: { title: "门店日记录", closable: true },
            },
            {
                path: "/main/shoukuan/hz",
                name: "shoukuan_hz",
                component: () => import(/* webpackChunkName: "shoukuan" */ "./views/1收款/3收款汇总.vue"),
                meta: { title: "收款汇总", closable: true },
            },
            {
                path: "/main/shoukuan/js",
                name: "shoukuan_js",
                component: () => import(/* webpackChunkName: "shoukuan" */ "./views/1收款/4结算记录.vue"),
                meta: { title: "结算记录", closable: true },
            },

            //分账
            {
                path: "/main/fenzhang/ktfz",
                name: "fenzhang_ktfz",
                component: () => import(/* webpackChunkName: "fenzhang" */ "./views/2分账/1开通分账.vue"),
                meta: { title: "开通分账", closable: true },
            },
            {
                path: "/main/fenzhang/rzf",
                name: "fenzhang_rzf",
                component: () => import(/* webpackChunkName: "fenzhang" */ "./views/2分账/2入账方.vue"),
                meta: { title: "入账方", closable: true },
            },
            {
                path: "/main/fenzhang/fqfz",
                name: "fenzhang_fqfz",
                component: () => import(/* webpackChunkName: "fenzhang" */ "./views/2分账/3发起分账.vue"),
                meta: { title: "发起分账", closable: true },
            },
            //餐饮收银系统
            {
                path: "/main/canyin/yyrtj",
                name: "canyin_yyrtj",
                component: () => import(/* webpackChunkName: "canyin" */ "./views/2餐饮收银系统/1营业日统计.vue"),
                meta: { title: "营业日统计", closable: true },
            },
            {
                path: "/main/canyin/sptj",
                name: "canyin_sptj",
                component: () => import(/* webpackChunkName: "canyin" */ "./views/2餐饮收银系统/2商品统计.vue"),
                meta: { title: "商品统计", closable: true },
            },
            {
                path: "/main/canyin/yhtj",
                name: "canyin_yhtj",
                component: () => import(/* webpackChunkName: "canyin" */ "./views/2餐饮收银系统/3优惠统计.vue"),
                meta: { title: "优惠统计", closable: true },
            },
            {
                path: "/main/canyin/sktj",
                name: "canyin_sktj",
                component: () => import(/* webpackChunkName: "canyin" */ "./views/2餐饮收银系统/4收款统计.vue"),
                meta: { title: "收款统计", closable: true },
            },
            {
                path: "/main/canyin/skrtj",
                name: "canyin_skrtj",
                component: () => import(/* webpackChunkName: "canyin" */ "./views/2餐饮收银系统/7收款日统计.vue"),
                meta: { title: "收款日统计", closable: true },
            },

            //会员
            {
                path: "/main/huiyuan/gk",
                name: "huiyuan_gk",
                component: () => import(/* webpackChunkName: "huiyuan" */ "./views/3会员/1会员概况.vue"),
                meta: { title: "会员概况", closable: true },
            },
            {
                path: "/main/huiyuan/list",
                name: "huiyuan_list",
                component: () => import(/* webpackChunkName: "huiyuan" */ "./views/3会员/2会员列表.vue"),
                meta: { title: "会员列表", closable: true },
            },
            {
                path: "/main/huiyuan/czxfjl",
                name: "huiyuan_czxfjl",
                component: () => import(/* webpackChunkName: "huiyuan" */ "./views/3会员/3充值消费记录.vue"),
                meta: { title: "充值消费记录", closable: true },
            },
            {
                path: "/main/huiyuan/jyhz",
                name: "huiyuan_jyhz",
                component: () => import(/* webpackChunkName: "huiyuan" */ "./views/3会员/5交易汇总.vue"),
                meta: { title: "交易汇总", closable: true },
            },
            {
                path: "/main/huiyuan/jyph",
                name: "huiyuan_jyph",
                component: () => import(/* webpackChunkName: "huiyuan" */ "./views/3会员/6会员交易排行.vue"),
                meta: { title: "交易排行", closable: true },
            },
            {
                path: "/main/huiyuan/kkbmd",
                name: "huiyuan_kkbmd",
                component: () => import(/* webpackChunkName: "huiyuan" */ "./views/3会员/7开卡白名单.vue"),
                meta: { title: "开卡白名单", closable: true },
            },
            {
                path: "/main/huiyuan/klxsz",
                name: "huiyuan_klxsz",
                component: () => import(/* webpackChunkName: "huiyuan" */ "./views/3会员/9卡类型设置.vue"),
                meta: { title: "卡类型设置", closable: true },
            },

            //优惠券
            {
                path: "/main/youhuiquan/search",
                name: "huiyuan_search",
                component: () => import(/* webpackChunkName: "youhuiquan" */ "./views/4优惠券/2优惠券查询.vue"),
                meta: { title: "优惠券查询", closable: true },
            },
            {
                path: "/main/youhuiquan/setting",
                name: "huiyuan_setting",
                component: () => import(/* webpackChunkName: "youhuiquan" */ "./views/4优惠券/3优惠券设置.vue"),
                meta: { title: "优惠券设置", closable: true },
            },

            //进销存
            {
                path: "/main/jinxiaocun/kc",
                name: "jinxiaocun_kc",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/0原料库存.vue"),
                meta: { title: "原料库存", closable: true },
            },
            {
                path: "/main/jinxiaocun/crkmx",
                name: "jinxiaocun_crkmx",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/0出入库明细.vue"),
                meta: { title: "出入库明细", closable: true },
            },
            {
                path: "/main/jinxiaocun/crktj",
                name: "jinxiaocun_crktj",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/0出入库统计.vue"),
                meta: { title: "出入库统计", closable: true },
            },

            {
                path: "/main/jinxiaocun/rkd",
                name: "jinxiaocun_rkd",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/1入库单.vue"),
                meta: { title: "入库单", closable: true },
            },
            {
                path: "/main/jinxiaocun/rkmx",
                name: "jinxiaocun_rkmx",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/1入库明细.vue"),
                meta: { title: "入库明细", closable: true },
            },
            {
                path: "/main/jinxiaocun/rktj",
                name: "jinxiaocun_rktj",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/1入库统计.vue"),
                meta: { title: "入库统计", closable: true },
            },

            {
                path: "/main/jinxiaocun/ckd",
                name: "jinxiaocun_ckd",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/2出库单.vue"),
                meta: { title: "出库单", closable: true },
            },
            {
                path: "/main/jinxiaocun/ckmx",
                name: "jinxiaocun_ckmx",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/2出库明细.vue"),
                meta: { title: "出库明细", closable: true },
            },
            {
                path: "/main/jinxiaocun/cktj",
                name: "jinxiaocun_cktj",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/2出库统计.vue"),
                meta: { title: "出库统计", closable: true },
            },

            {
                path: "/main/jinxiaocun/dbd",
                name: "jinxiaocun_dbd",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/3调拨单.vue"),
                meta: { title: "调拨单", closable: true },
            },
            {
                path: "/main/jinxiaocun/dbmx",
                name: "jinxiaocun_ckmx",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/3调拨明细.vue"),
                meta: { title: "调拨明细", closable: true },
            },
            {
                path: "/main/jinxiaocun/dbtj",
                name: "jinxiaocun_dbtj",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/3调拨统计.vue"),
                meta: { title: "调拨统计", closable: true },
            },
            {
                path: "/main/jinxiaocun/pdd",
                name: "jinxiaocun_pdd",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/8盘点单.vue"),
                meta: { title: "盘点单", closable: true },
            },
            {
                path: "/main/jinxiaocun/setup",
                name: "jinxiaocun_setup",
                component: () => import(/* webpackChunkName: "jinxiaocun" */ "./views/8进销存/9设置.vue"),
                meta: { title: "设置", closable: true },
            },

            //设置
            {
                path: "/main/setup/sh",
                name: "setup_sh",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/1商户资料.vue"),
                meta: { title: "商户资料", closable: true },
            },
            {
                path: "/main/setup/yg",
                name: "setup_yg",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/员工.vue"),
                meta: { title: "员工", closable: true },
            },
            // {
            //     path: "/main/setup/yg",
            //     name: "setup_yg",
            //     component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/员工旧.vue"),
            //     meta: { title: "员工", closable: true },
            // },
            {
                path: "/main/setup/role",
                name: "setup_role",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/角色.vue"),
                meta: { title: "角色", closable: true },
            },
            {
                path: "/main/setup/md",
                name: "setup_md",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/门店.vue"),
                meta: { title: "门店", closable: true },
            },
            {
                path: "/main/setup/sp",
                name: "setup_sp",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/商品.vue"),
                meta: { title: "商品", closable: true },
            },

            {
                path: "/main/setup/bom",
                name: "setup_bom",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/商品bom.vue"),
                meta: { title: "商品BOM", closable: true },
            },

            {
                path: "/main/setup/ycl",
                name: "setup_ycl",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/原材料.vue"),
                meta: { title: "原材料", closable: true },
            },

            {
                path: "/main/setup/psxl",
                name: "setup_psxl",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/配送线路.vue"),
                meta: { title: "配送线路", closable: true },
            },
            {
                path: "/main/setup/gys",
                name: "setup_gys",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/供应商.vue"),
                meta: { title: "供应商", closable: true },
            },
            {
                path: "/main/setup/dymb",
                name: "setup_dymb",
                component: () => import(/* webpackChunkName: "setup" */ "./views/9设置/打印模板.vue"),
                meta: { title: "打印模板", closable: true },
            },

            //---------------
            {
                path: "/main/tool/excell",
                name: "tool_excell",
                component: () => import(/* webpackChunkName: "tool" */ "./views/tool/导出excell下载中心.vue"),
                meta: { title: "导出excell下载中心", closable: true },
            },
            {
                path: "/main/tool/test",
                name: "tool_test",
                component: () => import(/* webpackChunkName: "tool" */ "./views/tool/test.vue"),
                meta: { title: "测试", closable: true },
            },
            {
                path: "/main/tool/sf",
                name: "tool_sf",
                component: () => import(/* webpackChunkName: "tool" */ "./views/tool/sf.vue"),
                meta: { title: "收费项目", closable: true },
            },
            {
                path: "/main/tool/hy",
                name: "tool_hy",
                component: () => import(/* webpackChunkName: "tool" */ "./views/tool/会员.vue"),
                meta: { title: "会员", closable: true },
            },
            {
                path: "/main/tool/api",
                name: "tool_api",
                component: () => import(/* webpackChunkName: "tool" */ "./views/tool/api.vue"),
                meta: { title: "API接口", closable: true },
            },

            //配送中心
            {
                path: "/main/peisong/dhd",
                name: "peisong_dhd",
                component: () => import(/* webpackChunkName: "peisong" */ "./views/7配送中心/1订货单.vue"),
                meta: { title: "订货单", closable: true },
            },
            {
                path: "/main/peisong/mx",
                name: "peisong_mx",
                component: () => import(/* webpackChunkName: "peisong" */ "./views/7配送中心/2订货明细.vue"),
                meta: { title: "订货明细", closable: true },
            },
            {
                path: "/main/peisong/tj",
                name: "peisong_tj",
                component: () => import(/* webpackChunkName: "peisong" */ "./views/7配送中心/3订货统计.vue"),
                meta: { title: "订货统计", closable: true },
            },
            {
                path: "/main/peisong/mddhd1",
                name: "peisong_mddhd1",
                component: () => import(/* webpackChunkName: "peisong" */ "./views/7配送中心/门店订货单1.vue"),
                meta: { title: "门店订货单", closable: true },
            },
            {
                path: "/main/peisong/mdmx",
                name: "peisong_mdmx",
                component: () => import(/* webpackChunkName: "peisong" */ "./views/7配送中心/门店订货明细.vue"),
                meta: { title: "门店订货明细", closable: true },
            },
            {
                path: "/main/peisong/mdtj",
                name: "peisong_mdtj",
                component: () => import(/* webpackChunkName: "peisong" */ "./views/7配送中心/门店订货统计.vue"),
                meta: { title: "门店订货统计", closable: true },
            },
            {
                path: "/main/peisong/thd",
                name: "peisong_thd",
                component: () => import(/* webpackChunkName: "peisong" */ "./views/7配送中心/退货单.vue"),
                meta: { title: "退货单", closable: true },
            },
        ],
    },
    { path: "/login", name: "login", component: () => import(/* webpackChunkName: "login" */ "./views/login.vue") },
    { path: "/psw", name: "psw", component: () => import(/* webpackChunkName: "login" */ "./views/psw.vue") },
    { path: "/reg", name: "reg", component: () => import(/* webpackChunkName: "login" */ "./views/reg.vue") },
];

const router = new VueRouter({
    routes,
});
export default router;
